import * as components from './components'

export default [
  {
    path: '/group/:uuid/home',
    component: components.GroupDetail,
    name: 'groupDetail',
    props: true
  },
  {
    path: '/group/list',
    component: components.GroupList,
    name: 'groupList',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/group/routes.js